import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import CardBasic from '../../../components/Cards/Basic';
import PageHeading from '../../../components/PageHeading';
import PrintingHeader from '../../../components/PrintingHeader';
import ModalOverDemand from 'react-bootstrap/Modal';

import * as actions from '../../../redux/actions';
import { fetchAnnualPairing } from '../../../redux/actions/report';
import { Button } from 'reactstrap';
import { formatCurrency } from '../../../constants/utility';

const AnnualPairing = (props) => {
  const { name, title, parent } = props.data;
  const { annualPairing } = useSelector((state) => state.report);
  const { public_id } = useSelector((state) => state.auth.data);
  const { profile } = useSelector((state) => state.account);

  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      id: public_id,
      filter: {},
    };
    dispatch(fetchAnnualPairing(params));
  }, [])


  useEffect(() => {
    dispatch(
      actions.setMenuActive({ menuActive: parent || name, subMenuActive: name })
    );
  }, [dispatch, name, parent]);

  const columns = [
    {
      dataField: '_',
      text: 'No',
      headerClasses: 'py-2 px-2 text-center',
      classes: 'p-2',
      headerStyle: (colum, colIndex) => {
        return { width: '40px' };
      },
      formatter: (cel, row, rowIndex) => rowIndex + 1,
      footer: '',
      footerClasses: 'text-center',
      classes: 'p-2 text-center',
    },
    {
      dataField: '_',
      text: 'Periode',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      footerClasses: 'text-center',
      formatter: (val) => <div>13 Juni 2024 - 15 Juni 2025</div>,
      footer: '',
    },
    {
      dataField: 'jumlah_bv_kiri_each_year',
      text: 'BV Kiri',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      footerClasses: 'text-center',
      footer: '',
    },
    {
      dataField: 'jumlah_bv_kanan_each_year',
      text: 'BV Kanan',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      footerClasses: 'text-center',
      footer: '',
    },
    {
      dataField: 'jumlah_pair_bv_each_year',
      text: 'Annual Pairing',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      footerClasses: 'text-center',
      footer: '',
    },
  ];

  return (
    <div>
      <PageHeading title={title} />
      <CardBasic nopadding>
        <div className="d-flex justify-content-between m-2">
          <div className="d-flex">
            {/* informasi annual pairing */}
            {
              show && (
                <ModalOverDemand show={show} size='xl'>
                  <ModalOverDemand.Header style={{ background: '#52567a' }}>
                    <ModalOverDemand.Title style={{ color: 'white' }}>
                      <div style={{ fontSize: '20px' }}>
                        <i className='fa fa-info mr-3'> </i>
                        <strong>Annual Pairing</strong>
                      </div>
                    </ModalOverDemand.Title>
                  </ModalOverDemand.Header>
                  <ModalOverDemand.Body>
                    <div style={{ marginTop: '16px', padding: '5px' }}>
                      <strong style={{ fontSize: '16px', color: '#343a40' }}>
                        Annual Pairing Rank
                      </strong>

                      {annualPairing?.annualPairingRank?.length > 0 && (
                        <div
                          style={{
                            marginTop: '10px',
                            overflowX: 'auto',
                            overflowY: 'auto',
                            maxHeight: '300px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                            backgroundColor: '#f8f9fa',
                          }}
                        >
                          <table
                            style={{
                              width: '100%',
                              minWidth: '500px',
                              borderCollapse: 'collapse',
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: '#e9ecef' }}>
                                <th
                                  style={{
                                    padding: '12px 16px',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    color: '#495057',
                                    borderBottom: '1px solid #ced4da',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Level
                                </th>
                                <th
                                  style={{
                                    padding: '12px 16px',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    color: '#495057',
                                    borderBottom: '1px solid #ced4da',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Minimal Pairing
                                </th>
                                <th
                                  style={{
                                    padding: '12px 16px',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    color: '#495057',
                                    borderBottom: '1px solid #ced4da',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Bonus
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {annualPairing.annualPairingRank.map((get, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f3f5',
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: '12px 16px',
                                      fontSize: '13px',
                                      color: '#343a40',
                                      borderBottom: '1px solid #dee2e6',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {get.level}
                                  </td>
                                  <td
                                    style={{
                                      padding: '12px 16px',
                                      fontSize: '13px',
                                      color: '#343a40',
                                      borderBottom: '1px solid #dee2e6',
                                      whiteSpace: 'nowrap',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {get.minimal_pair}
                                  </td>
                                  <td
                                    style={{
                                      padding: '12px 16px',
                                      fontSize: '13px',
                                      color: '#343a40',
                                      borderBottom: '1px solid #dee2e6',
                                      whiteSpace: 'nowrap',
                                      textAlign: 'right',
                                    }}
                                  >
                                    {
                                      formatCurrency(get.nilai_bonus)
                                    }
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>



                  </ModalOverDemand.Body>
                  <ModalOverDemand.Footer>
                    <Button variant='secondary' onClick={() => setShow(false)} size="sm">
                      Tutup
                    </Button>
                  </ModalOverDemand.Footer>
                </ModalOverDemand>
              )
            }

            <div style={{ margin: '4px' }}>
              <span
                onClick={(() => setShow(true))}
                title="Lihat informasi"
                style={{
                  fontSize: '12px',
                  color: '#6c757d', // gray primary text
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  backgroundColor: '#f1f3f5', // light gray
                  padding: '8px 12px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease-in-out',
                  display: 'inline-flex',
                  alignItems: 'center',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#6c757d'; // darker gray on hover
                  e.currentTarget.style.color = '#ffffff'; // white text
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#f1f3f5';
                  e.currentTarget.style.color = '#6c757d';
                  e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.04)';
                }}
              >
                <i
                  className="fa fa-info-circle"
                  style={{
                    fontSize: '12px',
                    marginRight: '6px',
                  }}
                ></i>
                Informasi Annual Pairing
              </span>
            </div>
          </div>

        </div>

        <div className="table-fixed custom-scrollbar table-responsive my-table">
          <div className="container-print media-print-p2" >
            <PrintingHeader
              title={'Laporan Annual Pairing'}
              subtitle={
                profile ? <div className='text-center font-weight-bold text-xs mb-2'> {profile?.nama} - {profile?.id_member}</div> : ''
              }
            />

            <div className="bt-table mt-4">
              <BootstrapTable
                className="bt-table"
                bootstrap4
                hover
                condensed
                noDataIndication={() => {
                  return 'No data';
                }}
                bordered={false}
                keyField="id"
                data={annualPairing?.rows || []}
                columns={columns}
              />
            </div>

          </div>
        </div>
      </CardBasic>
    </div>
  );
};

export default AnnualPairing;
